(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback(){ this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver(){
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect; observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal && !this.headerIsAlwaysSticky) requestAnimationFrame(this.reveal.bind(this));
        else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(()=>{ this.preventReveal=false; },66); if(!this.headerIsAlwaysSticky) requestAnimationFrame(this.hide.bind(this)); }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header'); if(!this.headerIsAlwaysSticky) requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide(){ this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); }
    reveal(){ this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
  }
  customElements.define('sticky-header', StickyHeader);
    // =======================================================
  // MMG MOBILE DRAWER OPEN/CLOSE
  // - Click hamburger to open
  // - Click overlay/right side OR X to close
  // - ESC closes
  // - Locks background scroll while open
  // =======================================================
    // =======================================================
  // MMG MOBILE DRAWER OPEN/CLOSE (Shopify-safe)
  // =======================================================
  function initMmgDrawer(){
    const btn = document.getElementById('mmg-hamburger');
    const drawer = document.getElementById('mmg-drawer');
    if (!btn || !drawer) return;

    // prevent double-binding if Shopify re-renders sections
    if (drawer.dataset.mmgBound === 'true') return;
    drawer.dataset.mmgBound = 'true';

    const closeTargets = drawer.querySelectorAll('[data-close]');

    let lastActive = null;

    const openDrawer = () => {
      if (!drawer.hasAttribute('hidden')) return;
      lastActive = document.activeElement;

      drawer.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');

      document.documentElement.classList.add('mmg-drawer-open');
      document.body.classList.add('mmg-drawer-open');
    };

    const closeDrawer = () => {
      if (drawer.hasAttribute('hidden')) return;

      drawer.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');

      document.documentElement.classList.remove('mmg-drawer-open');
      document.body.classList.remove('mmg-drawer-open');

      if (lastActive && typeof lastActive.focus === 'function') lastActive.focus({ preventScroll: true });
      else btn.focus({ preventScroll: true });
    };

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });

    closeTargets.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // Run now (script is after markup, so elements exist)
  initMmgDrawer();

  // Run again if Shopify editor reloads/refreshes the section
  document.addEventListener('shopify:section:load', initMmgDrawer);



  } catch(e) { console.error(e); }
})();
})();
